const normalizeSearchText = (value: unknown): string => String(value ?? '').trim().toLowerCase();

const getEntityName = (value: any): string => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (typeof value.displayName === 'string' && value.displayName.trim()) return value.displayName;
  if (typeof value.name === 'string' && value.name.trim()) return value.name;

  const firstName = typeof value.firstName === 'string' ? value.firstName : '';
  const lastName = typeof value.lastName === 'string' ? value.lastName : '';
  return [firstName, lastName].filter(Boolean).join(' ');
};

const isPurchasedGoodsProject = (project: any): boolean => {
  const orderType = normalizeSearchText(project?.orderType);
  return (
    orderType === 'purchased-goods' ||
    normalizeSearchText(project?.itemType) === 'purchased goods' ||
    Boolean(project?.purchasedGoodsItemType)
  );
};

const getPurchasedGoodsSearchValues = (project: any): string[] => {
  const itemName = project?.purchasedGoodsItemType?.name || project?.itemType || '';
  const supplierName = getEntityName(project?.purchasedGoodsSupplier);
  const itemDisplay =
    itemName && supplierName ? `${itemName} - ${supplierName}` : itemName || supplierName;

  return [
    itemDisplay,
    itemName,
    supplierName,
    project?.clientName,
    getEntityName(project?.client),
    getEntityName(project?.mainParent),
    getEntityName(project?.parent),
    project?.roomName,
    project?.customRoom,
    project?.room,
    project?.status,
    project?.workOrderNum,
    project?.workOrderId,
    project?.workOrder,
    project?.estimateNumber,
    project?.estimateStatus,
    project?.qbEstimateNumber,
    project?.invoiceNumber,
    project?.invoicePaid,
    project?.purchasedGoodsNotes,
    project?.purchasedGoodsWindowLocationId,
    project?.notes,
    project?.note,
  ];
};

export const filterFalsePositivePurchasedGoodsForOverviewSearch = <T>(
  projects: T[],
  searchTerm: unknown
): T[] => {
  const normalizedSearch = normalizeSearchText(searchTerm);
  if (!normalizedSearch) return projects;

  return projects.filter((project: any) => {
    if (!isPurchasedGoodsProject(project)) return true;

    const searchableValues = getPurchasedGoodsSearchValues(project);
    return searchableValues.some((value) =>
      normalizeSearchText(value).includes(normalizedSearch)
    );
  });
};

